 import React from 'react';
import './aboutus.css';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import aboutHero from "../assets/Aboutus.jpg"; 

const AboutUs = () => {
  return (
    <div className="about-page">
      <Navbar />

      <section className="about-hero">
        <img src={aboutHero} alt="Pakistan Forest and Wildlife" />
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>About Ecovibe</h1>
        </div>
      </section>

      <section className="section">
        <div className="container narrow">
          <p className="lead">
            Ecovibe is a citizen-driven platform dedicated to protecting Pakistan’s environment. 
            We believe that access to clear information is the first step toward meaningful action.
          </p>
        </div>
      </section>

      <section className="section bg-light">
        <div className="container">
          <h2 className="section-title">The Challenge in Pakistan</h2>
          <div className="two-col">
            <div className="col">
              <p>
                Pakistan is one of the most climate-vulnerable countries in the world. We face air pollution, 
                water scarcity, deforestation, and loss of biodiversity. Smog in Lahore, floods in Sindh, 
                and melting glaciers in the north are daily reminders of this crisis.
              </p>
            </div>
            <div className="col">
              <p>
                The biggest gap is awareness. People want to help but don’t know how. Ecovibe was built 
                to bridge that gap by providing local data, simple guides, and a direct way to report issues.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="two-col">
            <div className="col">
              <h2>Our Mission</h2>
              <p>
                To educate, enable, and empower citizens to protect the 6 key pillars of our ecosystem: 
                Sun, Water, Trees, Birds, Air, and Land.
              </p>
            </div>
            <div className="col">
              <h2>Our Vision</h2>
              <p>
                A Pakistan where every community is informed, engaged, and actively working to restore 
                and protect its local environment.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-light">
        <div className="container">
          <h2 className="section-title">Our Approach</h2>
          <div className="card-grid">
            <div className="card">
              <h3>Educate</h3>
              <p>Publish research-based articles and guides in simple language about environmental issues in Pakistan.</p>
            </div>
            <div className="card">
              <h3>Report</h3>
              <p>Provide a simple tool for citizens to report pollution, illegal tree cutting, and waste dumping.</p>
            </div>
            <div className="card">
              <h3>Connect</h3>
              <p>Link citizens with NGOs, government campaigns, and local community clean-up drives.</p>
            </div>
            <div className="card">
              <h3>Track</h3>
              <p>Show transparent results. Track reports solved, trees planted, and areas cleaned.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section quote">
        <div className="container narrow">
          <p>"The environment is where we all meet. It is the one thing all of us share."</p>
        </div>
      </section>

      <section className="section">
        <div className="container narrow">
          <h2 className="section-title">Our Team</h2>
          <div className="team-credit">
            <p><strong>Developed by:</strong> Swera Shahzadi, Nimra Komal, Amina Ashraf</p>
            <p><strong>Institution:</strong> Department of  Information Technology, University of the Punjab, Lahore</p>
            <p><strong>Academic Supervisor:</strong>Sir Ubaid Ullah</p>
            <span className="tag">Final Year Project 2026</span>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUs;